<template>
  <div :class="$style.formContainer"><slot /></div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.formContainer {
  max-width: $funnel-container-max-width;
  margin: 0 auto $space-800 auto;
}
</style>
<script setup lang="ts"></script>
